'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

var environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];

module.exports = (0, _assign2.default)({

  host: process.env.HOST || 'localhost',
  port: process.env.PORT,
  apiHost: process.env.APIHOST || 'localhost',
  apiPort: process.env.APIPORT,
  app: {
    title: 'Karmapa Digital Toolbox',
    description: '',
    head: {
      titleTemplate: 'Karmapa Digital Toolbox: %s',
      meta: [{ name: 'description', content: '' }, { charset: 'utf-8' }, { property: 'og:site_name', content: 'Karmapa Digital Toolbox' }, { property: 'og:image', content: '' }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: 'Karmapa Digital Toolbox' }, { property: 'og:description', content: '' }, { property: 'og:card', content: 'summary' }, { property: 'og:site', content: '@kmsheng' }, { property: 'og:creator', content: '@kmsheng' }, { property: 'og:image:width', content: '200' }, { property: 'og:image:height', content: '200' }]
    }
  }

}, environment);


/*****************
 ** WEBPACK FOOTER
 ** ./src/config.js
 ** module id = 543
 ** module chunks = 0
 **/